import React from "react"
import { TimelineItem } from "@humanpredictiveintelligence/myqvt-library"
import { t } from "ttag"

import {
  ThemeQuestion,
  ThemeWithQuestionsNested,
} from "features/Surveys/CustomSurveys/models"
import * as Styles from "./ThemeQuestionItem.styles"

export const ThemeQuestionItem: React.FC<ThemeQuestionsSectionProps> = (props) => {
  return (
    <TimelineItem
      borderColor={props.theme.color}
      label={t`Question` + ` ${props.questionIndex + 1}`}
    >
      <Styles.Question.Wording>{props.question.name}</Styles.Question.Wording>
      <Styles.Question.Choices
        questionId={props.question.id}
        isOpen={props.areChoicesOpen}
        onClose={() => props.onChoicesClose()}
        onOpen={() => props.onChoicesOpen()}
      />
      <Styles.Question.Action
        isDisabled={props.isReadOnly}
        icon={props.isQuestionSelected ? "check" : "add"}
        onClick={() => props.onQuestionToggled()}
        isInverted
      />
    </TimelineItem>
  )
}

interface ThemeQuestionsSectionProps {
  theme: ThemeWithQuestionsNested,
  questionIndex: number,
  question: ThemeQuestion,
  onQuestionToggled: () => void,
  areChoicesOpen: boolean,
  isReadOnly: boolean,
  isQuestionSelected: boolean,
  onChoicesOpen: () => void,
  onChoicesClose: () => void,
}
